import RatingScale from '../../core/RatingScale';
import classNames from 'classnames';
import Input from '@components/legacy/core/Input';
import './index.less';
import { useState } from 'react';

const EvaluationAttributeItem = ({
    title,
    attribute,
    score,
    question,
    readOnly,
    onChange = () => { },
    onChangeImmediate = null,
    ratingScale,
    show = true,
    answer: initialAnswer,
}) => {
    const [answer, setAnswer] = useState(initialAnswer);

    const onAnswerChangeHandler = (value) => {
        setAnswer(value);
        if (onChangeImmediate) {
            onChangeImmediate(attribute, 'answer', value);
        } else {
            onChange(attribute, 'answer', value);
        }
    };

    const onAnswerBlurHandler = (value) => {
        onChange(attribute, 'answer', value);
    };

    return (
        <div className='applicant-evaluation-row'>
            <div className='applicant-evaluation-row-title'>
                <h6>{title}</h6>
                {ratingScale && (
                    <RatingScale
                        readOnly={readOnly}
                        value={score}
                        onChange={(value) => onChange(attribute, 'score', value)}
                        options={ratingScale?.options}
                    />
                )}
            </div>
            {question?.trim() && (
                <div
                    className={classNames('feedback-input', {
                        show: show,
                    })}
                >
                    <Input
                        label={question}
                        type='textarea'
                        readOnly={readOnly}
                        value={answer}
                        onChange={onAnswerChangeHandler}
                        onBlur={onAnswerBlurHandler}
                    />
                </div>
            )}
        </div>
    );
};

export default EvaluationAttributeItem;
